import { SET_CRITICAL_DEVIATIONS, DeviationsActionTypes, DeviationsList } from '../../types/DeviationTypes';

export const setCriticalDeviations = (messages: DeviationsList): DeviationsActionTypes => ({
  type: SET_CRITICAL_DEVIATIONS,
  payload: messages,
});
